import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Starfield from "@/components/Starfield";
import HomePage from "@/pages/HomePage";
import EducationPage from "@/pages/EducationPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative bg-navy min-h-screen" data-testid="app-root">
      <Starfield />
      <div className="grain-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EducationPage />} />
          <Route path="/site" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFDF6",
            border: "1px solid rgba(184,150,42,0.4)",
            color: "#16223D",
          },
        }}
      />
    </div>
  );
}

export default App;
